export const B2B_LOGO_ALT = "B2B Logo";
export const HOPPER_LOGO_ALT = "Hopper Logo";
